import { styled } from 'styled-components';

export const FieldWrapper = styled.div<{ $maxWidth?: string }>`
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth ?? '100%'};
  span {
    flex: 1;
  }

  > div {
    flex: 1;
    width: 100%;
  }
`;
